export default __webpack_public_path__ + "81c0a0b4031d2879da0930c823440db3.svg";